export default "/fonts/Poppins-SemiBold.ttf?ec09da7214e9dc1e86ca161053cc6ad7";